import React, { useEffect, useState } from "react";
import TrashIcon from "assets/icon/TrashIcon";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString, FormTypeAdd, FormTypeEdit, PageSize, PaginationBack, PaginationFirst, PaginationLast, PaginationNext, StatusCodeActive } from "utils/Constant";
import { ApiGetLocationList, ApiDeleteLocation, ApiCheckLocationQuota } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import EditIcon from "assets/icon/EditIcon";
import PaginationButton from "components/Input/PaginationButton";
import SearchButton from "components/Button/SearchButton";
import AddButton from "components/Button/AddButton";
import { GetStatus } from "utils/helpers";
import RevisionIcon from "assets/icon/RevisionIcon";

export default function Location(){
    let navigate = useNavigate()
    
    const { data: locationList, fetch: apiGetLocation } = useFetch(ApiGetLocationList)
    const { fetch: apiDeleteLocation } = useFetch(ApiDeleteLocation)
    const { fetch: apiCheckLocationQuota } = useFetch(ApiCheckLocationQuota)

    const [locationName, setLocationName] = useState(EmptyString)
    const [address, setAddress] = useState(EmptyString)
    const [city, setCity] = useState(EmptyString)
    const [allowAdd, setAllowAdd] = useState(true)
    const [locationQuota, setLocationQuota] = useState('')
    const [currentLocationCount, setCurrentLocationCount] = useState('')

    // Grid
    const[paginationOptions, setPaginationOptions] = useState([])
    const[pageIndex, setPageIndex] = useState("")
    const[totalPageCount, setTotalPageCount] = useState(0)

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    // Function Api Call
    const getLocationList = async (index) => {
        let res

        await apiGetLocation({
            data: {
                locationName: locationName,
                address: address,
                city: city,
                status: '1',
                companyId: localStorage.getItem("CompanyId"),
                pageSize: PageSize,
                pageIndex: parseInt(index)
            }
        }).then((response) => {
            if (checkResponse(response)) {
                res = response
            }
        })

        return res
    }
    const deleteLocation = async (locationId, status) => {
        await apiDeleteLocation({
            data: {
                locationId: locationId,
                status: status
            }
        }).then((response) => {
            if (checkResponse(response)) {
                setSuccessModal({ 
                    isOpen: true, 
                    data: {
                        onSuccess: async () => {
                            setSuccessModal({ isOpen: false })
                        }
                    }
                })
            }
        })
    }
    const checkLocationQuota = async () => {
        let res

        await apiCheckLocationQuota({
            data: { }
        }).then((response) => {
            if (checkResponse(response)) {
                res = response
            }
        })

        return res
    }

    // Function Grid
    async function fBindGrid(index){
        setLoading({isOpen: true})

        let i = index !== null ? (index !== "" ? parseInt(index) : 0) : 0

        getLocationList(i).then((res) => {
            if (res !== null){
                let totalData = res.data.totalData
                fSetPaginationOptions(totalData, index)
            }
            setLoading({isOpen: false})
        })
    }
    function fSetPaginationOptions(dataCount, index){
        let numberOfPage = parseInt(parseInt(dataCount)/PageSize)
        let array = []
        
        setTotalPageCount(numberOfPage = 0 ? 1 : numberOfPage)

        for (let i = 0; i <= numberOfPage; i++){
            array.push({
                label: String(i + 1),
                value: String(i)
            })
        }
        
        setPaginationOptions(array)
        
        if(index !== "" && index !== null){
            setPageIndex(String(index))
        }else{
            setPageIndex("0")
        }
    }
    function fPaginationBtnClick(command){
        if(command === PaginationFirst){
            setPageIndex("0")
            fBindGrid(0)
        }else if(command === PaginationBack){
            let index = parseInt(pageIndex) - 1

            if(index >= 0){
                setPageIndex(index)
                fBindGrid(index)
            }
        }else if(command === PaginationNext){
            let index = parseInt(pageIndex) + 1

            if (totalPageCount >= index){
                setPageIndex(index)
                fBindGrid(index)
            }
        }else if(command === PaginationLast){
            let index = totalPageCount

            setPageIndex(index)
            fBindGrid(index)
        }
    }
    function fPaginationIndexChange(index){
        setPageIndex(index)
        fBindGrid(index)
    }

    // Button Event
    const searchBtnClick = () => {
        fBindGrid(0)
    }
    const addBtnClick = () => {
        navigate("/location/form?locationId=&formType=" + FormTypeAdd)
    }
    const editBtnClick = (id) => {
        navigate("/location/form?locationId=" + id + "&formType=" + FormTypeEdit)
    }
    const deleteBtnClick = (id, status) => {
        setConfirmationModal({
            isOpen: true,
            data: {
                onSuccess: async () => {
                    setConfirmationModal({ isOpen: false })
                    setLoading({isOpen: true})

                    deleteLocation(id, status).then(() => {
                        setLoading({isOpen: false})
                        fBindGrid(pageIndex)
                    })
                }
            }
        })
    }
    
    function fEnterKeyDown(e){
		if(e.key === 'Enter'){
			fBindGrid(0)
		}
	}

    const checkResponse = (response) => {
        if(response.status === ApiResponseSuccess){
                return true
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({ isOpen: false })
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })

                return false
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({ isOpen: false })
                        }
                    },
                    message: response.message
                })

                return false
            }
    }

    useEffect(() => {
        checkLocationQuota().then((res) => {
            if (res !== null) {
                if (res.data.canCreate){
                    setAllowAdd(true)
                } else {
                    setAllowAdd(false)
                }

                setLocationQuota(String(res.data.locationQuota))
                setCurrentLocationCount(String(res.data.locationUsed))
            }
        })
            
        fBindGrid(0)
    },[])

    return(
        <div className="flex flex-col gap-2">
            <div >
                <span className="font-semibold text-2xl">Location</span>
            </div>
            <hr />

            <div className="flex flex-col sm:flex-row justify-between gap-4 mt-5">
                <div className="flex flex-col sm:flex-row sm:flex-wrap gap-2 sm:gap-4">
                    <div className="flex flex-col gap-2 w-full sm:w-[280px]">
                        <span>Location Name</span>
                        <input className="input" value={locationName} onChange={(e) => { setLocationName(e.target.value) }} onKeyDown={(e) => { fEnterKeyDown(e) }} />
                    </div>
                    <div className="flex flex-col gap-2 w-full sm:w-[280px]">
                        <span>Address</span>
                        <input className="input" value={address} onChange={(e) => { setAddress(e.target.value) }} onKeyDown={(e) => { fEnterKeyDown(e) }} />
                    </div>
                </div>
                <div>
                    <div className="flex items-end justify-end h-full">
                        <SearchButton onClick={searchBtnClick} />
                    </div>
                </div>
            </div>

            <div className="flex w-full justify-end gap-4 mt-2">
                <div className="flex items-center">
                    <span>{currentLocationCount} location used of {locationQuota}</span>
                </div>
                { allowAdd && <AddButton onClick={addBtnClick} /> }
            </div>
           
            <div className="mt-2 overflow-hidden border rounded-3xl shadow-sm">
                <table className="w-full bg-white">
                    <thead>
                        <tr className="h-12">
                            <th className="font-semibold w-16">No</th>
                            <th className="font-semibold text-left px-2">Location Name</th>
                            <th className="font-semibold text-left px-2 hidden sm:table-cell">Address</th>
                            <th className="font-semibold text-left px-2 hidden md:table-cell">City</th>
                            <th className="font-semibold text-left px-2 hidden md:table-cell">Province</th>
                            <th className="font-semibold text-left px-2 hidden md:table-cell">Status</th>
                            <th className="font-semibold w-24">Action</th>
                        </tr>
                    </thead>
                    <tbody className="">
                        { locationList?.data?.listData?.length < 1 && (
                            <tr className="border-t">
                                <td colSpan={7} className="text-center py-3">
                                    <span>No Data Available</span>
                                </td>
                            </tr>
                        )}

                        { locationList?.data?.listData?.map((data, i) => {
                            return(
                                <tr className="my-2 row h-10 border-t" key={ i }>
                                    <td className="text-center">{ data.rowNumber }</td>
                                    <td className="px-2">
                                        <span>{ data.locationName }</span>
                                    </td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ data.address }</span>
                                    </td>
                                    <td className="px-2 hidden md:table-cell">
                                        <span>{ data.city }</span>
                                    </td>
                                    <td className="px-2 hidden md:table-cell">
                                        <span>{ data.province }</span>
                                    </td>
                                    <td className="px-2 hidden md:table-cell">
                                        <span>{ GetStatus(data.status) }</span>
                                    </td>
                                    <td className="flex justify-center py-2 gap-2 px-2">
                                        <button className={`button flex gap-2`} onClick={() => editBtnClick(data.locationId)}>
                                            <EditIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`button flex gap-2 ${ data.status === StatusCodeActive ? 'block' : 'hidden' }`} onClick={() => deleteBtnClick(data.locationId, data.status)}>
                                            { data.status === StatusCodeActive ? <TrashIcon className="w-4 fill-white" /> : <RevisionIcon className="w-4 fill-white" /> }
                                        </button>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>

            <PaginationButton 
                btnFirstClick={() => { fPaginationBtnClick(PaginationFirst) }} 
                btnBackClick={() => { fPaginationBtnClick(PaginationBack) }} 
                btnNextClick={() => { fPaginationBtnClick(PaginationNext) }}
                btnLastClick={() => { fPaginationBtnClick(PaginationLast) }}
                options={paginationOptions} 
                value={pageIndex} onChange={(e) => { fPaginationIndexChange(e.value) }} 
            />

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}